import type { Route } from '!/router'
import { keys } from '~/shared/jail'
import { Footer } from '~/shared/ui/components/Footer'
import { ProfilesCreatePopup, ProfilesRemovePopup } from '~/widgets/Popups'
import { AccountSettingsModal } from '~/features/portal/redirect'
import { NavBar } from '~/widgets/NavBar'
import * as root from '~/routes/404/root'

export const route: Route = {
  keys: [keys.app, keys.guest],

  children: [
    {
      path: '',
      component: [
        root.Title,
        NavBar,
        root.NotFoundPage,
        Footer,
        ProfilesRemovePopup,
        ProfilesCreatePopup,
        AccountSettingsModal,
      ],
      init: root.model.init,
    },
  ],
}
